// Brands, categories and destinations; translated text lives in src/i18n/locales/.
const definitions = [
  {
    id: 'signitic', name: 'Signitic', categoryKey: 'categories.emailSignatures',
    localizedDiscoverUrls: {
      en: 'https://www.signitic.com/en',
      fr: 'https://www.signitic.com/fr',
      de: 'https://www.signitic.com/de',
      it: 'https://www.signitic.com/it',
      pl: 'https://www.signitic.com/pl',
    },
    urls: {
      app: 'https://app.signitic.com/',
      try: 'https://www.signitic.com/en/try',
      discover: 'https://www.signitic.com/en',
    },
  },
  {
    id: 'user', name: 'User', categoryKey: 'categories.emailing',
    localizedDiscoverUrls: {
      fr: 'https://www.user.com/fr',
      de: 'https://www.user.com/de',
      es: 'https://www.user.com/es',
      it: 'https://www.user.com/it',
      pl: 'https://www.user.com/pl',
    },
    urls: {
      app: 'https://app.user.com/',
      try: 'https://app.user.com/accounts/register/',
      discover: 'https://www.user.com/',
    },
  },
  {
    id: 'surfer', name: 'Surfer', categoryKey: 'categories.seo',
    urls: {
      app: 'https://app.surferseo.com/',
      try: 'https://app.surferseo.com/register',
      discover: 'https://surferseo.com/',
    },
  },
  {
    id: 'iconosquare', name: 'Iconosquare', categoryKey: 'categories.socialMedia',
    localizedDiscoverUrls: {
      fr: 'https://www.iconosquare.com/fr',
      de: 'https://www.iconosquare.com/de',
      es: 'https://www.iconosquare.com/es',
    },
    urls: {
      app: 'https://app.iconosquare.com/',
      try: 'https://app.iconosquare.com/create/account',
      discover: 'https://www.iconosquare.com/?r=0',
    },
  },
  {
    id: 'humanlinker', name: 'Humanlinker', categoryKey: 'categories.sales',
    localizedDiscoverUrls: {
      fr: 'https://www.humanlinker.com/fr',
    },
    urls: {
      app: 'https://app.humanlinker.com/',
      try: 'https://app.humanlinker.com/signup',
      discover: 'https://www.humanlinker.com/',
    },
  },
  {
    id: 'ubic', name: 'Ubic', categoryKey: 'categories.sales',
    localizedDiscoverUrls: {
      en: 'https://www.getubic.com/en',
      fr: 'https://www.getubic.com/fr',
    },
    urls: {
      app: 'https://app.getubic.com/',
      try: 'https://app.getubic.com/register',
      discover: 'https://www.getubic.com/en',
    },
  },
  {
    id: 'nocrm', name: 'noCRM', categoryKey: 'categories.sales',
    localizedDiscoverUrls: {
      fr: 'https://www.nocrm.io/fr',
      de: 'https://www.nocrm.io/de',
      es: 'https://www.nocrm.io/es',
      it: 'https://www.nocrm.io/it',
      pt: 'https://www.nocrm.io/pt',
    },
    urls: {
      app: 'https://nocrm.io/sessions/signin',
      try: 'https://register.nocrm.io/',
      discover: 'https://www.nocrm.io/',
    },
  },
];

export const products = Object.freeze(definitions.map((product) => Object.freeze({
  ...product,
  logoId: product.id,
  translationKey: `products.${product.id}`,
  localizedDiscoverUrls: Object.freeze(product.localizedDiscoverUrls ?? {}),
  urls: Object.freeze(product.urls),
})));

// These hosts can use the nav without being offered as destinations in the catalog.
export const currentOnlyProducts = Object.freeze([
  { id: '4dem', name: '4DEM' },
  { id: 'mailingwork', name: 'Mailingwork' },
  { id: 'rapidmail', name: 'rapidmail' },
  { id: 'sarbacane', name: 'Sarbacane' },
].map((product) => Object.freeze({
  ...product,
  logoId: product.id,
  categoryKey: 'categories.emailing',
  currentOnly: true,
  urls: Object.freeze({}),
})));

export const knownProducts = Object.freeze([...products, ...currentOnlyProducts]);

// Omitted or false means enabled; true excludes the product everywhere.
export const isProductEnabled = (id) => knownProducts.some((product) => product.id === id && product.disabled !== true);
